import { NgIf } from '@angular/common';
import { Component, Output, EventEmitter } from '@angular/core';
import { EmrButtonComponent, EmrModalComponent } from 'emr-ng-shared';
import { BsModalRef } from 'ngx-bootstrap/modal';

export class CreateShipmentResponseOkEventArgs {
  modalRef: BsModalRef;
  hasError: boolean;
  closeOnOk: boolean;
}

@Component({
    selector: 'app-create-shipment-response',
    templateUrl: './create-shipment-response.component.html',
    styleUrls: ['./create-shipment-response.component.css'],
    standalone: true,
    imports: [EmrModalComponent, EmrButtonComponent, NgIf]
  })

  export class CreateShipmentResponseComponent {
    @Output() ok = new EventEmitter<CreateShipmentResponseOkEventArgs>();

    showCloseButton: false
    hasError = false;
    errorMessage: string = null;
    closeOnOk: boolean;
    debugErrorMessage = null;

    constructor(public bsModalRef: BsModalRef) {}

    onOkClick() {
      const args = new CreateShipmentResponseOkEventArgs();
      args.modalRef = this.bsModalRef;
      args.hasError = this.hasError;
      args.closeOnOk = this.closeOnOk;

      this.ok.emit(args);

      this.bsModalRef.hide();
    }
  }
